export const SSE_EVENTS = {
  HEARTBEAT: "heartbeat",
};

export const SSE_STATUS = {
  IDLE: "idle",
  CONNECTING: "connecting",
  OPEN: "open",
  RETRYING: "retrying",
  CLOSED: "closed",
  ERROR: "error",
};

export const buildSseKey = ({ resourceType, subject, userId }) =>
  `${resourceType}:${subject}:${userId}`;

export const safeJsonParse = (value) => {
  if (typeof value !== "string") return value;

  try {
    return JSON.parse(value);
  } catch (error) {
    return value;
  }
};
